/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { Editor } from '@monaco-editor/react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import { Story } from '@/commons/protocols';
import DisplayError from '@/components/atoms/Error';
import { useGet } from '@/net/commons';

const StoryList = () => {
    const [editorValue, setEditorValue] = useState<string>('{}');
    const { projectSlug, suiteSlug, storyId } = useParams();
    const [error, setError] = useState<any>(undefined);
    const {
        data: story,
        isLoading: isStoryLoading,
        error: errorStories,
    } = useGet<Story | undefined>(
        storyId ? `/bff/project/${projectSlug}/suite/${suiteSlug}/story/id/${storyId}` : null,
    );

    useEffect(() => {
        if (story) {
            try {
                setEditorValue(JSON.stringify(story, null, 2));
            } catch (e) {
                setError(e);
            }
        }
    }, [story, isStoryLoading]);

    return (
        <div className="w-2xl flex flex-col gap-2">
            {error && <DisplayError error={error} />}
            {errorStories && <DisplayError error={errorStories} />}
            {editorValue && (
                <Editor
                    height="75vh"
                    defaultLanguage="json"
                    value={editorValue}
                    onChange={(e) => {
                        e && setEditorValue(e);
                    }}
                />
            )}
        </div>
    );
};

export default StoryList;
